import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock } from "vue"

import type { Column, Table } from '@tanstack/vue-table';
    import { computed, PropType } from 'vue';
    import { useI18n } from 'vue-i18n';
    import SearchInput from '@/components/SearchInput.vue';
    import ColumnFilterCheckbox from '@/components/filters/ColumnFilterCheckbox.vue';
    import ColumnFilterDate from '@/components/filters/ColumnFilterDate.vue';
    import ColumnNumberRange from '@/components/filters/ColumnNumberRange.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ColumnFilter',
  props: {
        column: {
            type: Object as PropType<Column<any, unknown>>,
            required: true,
        },
        table: {
            type: Object as PropType<Table<any>>,
            required: true,
        },
    },
  setup(__props) {

    const { t, locale, messages } = useI18n();

    const props = __props;

    const columnFilterValue = computed(() => props.column.getFilterValue());

    const sortedUniqueValues = computed(() => {
        const preFilteredRows = props.table.getPreFilteredRowModel().flatRows;
        const valuesSet = new Set<string>();

        for (const row of preFilteredRows) {
            const value = row.getValue(props.column.id);
            if (typeof value === 'string') {
                valuesSet.add(value);
            }
        }

        return Array.from(valuesSet).sort();
    });

    const filterType = computed(() => {
        if (props.column.columnDef.meta?.filterType) {
            return props.column.columnDef.meta.filterType;
        }

        return 'text';
    });

    const checkboxOptions = computed(() => {
        if (filterType.value === 'status') {
            return [
                { value: 1, label: t('translations.status.active') },
                { value: 0, label: t('translations.status.inactive') },
            ];
        } else if (filterType.value === 'yesNo') {
            return [
                { value: 1, label: t('forms.yes') },
                { value: 0, label: t('forms.no') },
            ];
        } else if (filterType.value === 'companyStatus') {
            return [
                { value: 'active', label: t('translations.status.active') },
                { value: 'inactive', label: t('translations.status.inactive') },
                { value: 'deleted', label: t('translations.deleted') },
            ];
        } else if (filterType.value === 'month') {
            return monthOptions.value;
        }
        return sortedUniqueValues.value.map((value) => ({
            value: value,
            label: value,
        }));
    });

    const monthOptions = computed(() => {
        const months = (messages.value[locale.value] as any).salary.sheets.months;

        return Object.entries(months).map(([key, label]) => ({
            value: Number(key),
            label: label as string,
        }));
    });

    const handleCheckboxFilterChange = (values: (string | number)[]) => {
        props.column.setFilterValue(values.length > 0 ? values : undefined);
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (['checkbox', 'status', 'yesNo', 'month', 'companyStatus'].includes(filterType.value))
      ? (_openBlock(), _createBlock(ColumnFilterCheckbox, {
          key: 0,
          "column-id": __props.column.id,
          options: checkboxOptions.value,
          "model-value": Array.isArray(columnFilterValue.value) ? columnFilterValue.value : [],
          "onUpdate:modelValue": handleCheckboxFilterChange
        }, null, 8, ["column-id", "options", "model-value"]))
      : (filterType.value === 'dateRange')
        ? (_openBlock(), _createBlock(ColumnFilterDate, {
            key: 1,
            column: __props.column,
            "model-value": columnFilterValue.value as string | undefined,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => __props.column.setFilterValue(value))
          }, null, 8, ["column", "model-value"]))
        : (filterType.value === 'number' || filterType.value === 'currency')
          ? (_openBlock(), _createBlock(ColumnNumberRange, {
              key: 2,
              column: __props.column,
              "model-value": columnFilterValue.value as [number | undefined, number | undefined] | undefined,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = 
                (value) =>
                    __props.column.setFilterValue(value)
            )
            }, null, 8, ["column", "model-value"]))
          : (_openBlock(), _createBlock(SearchInput, {
              key: 3,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = (value) => __props.column.setFilterValue(value)),
              placeholder: _unref(t)('forms.search'),
              modelValue: columnFilterValue.value as string | number
            }, null, 8, ["placeholder", "modelValue"]))
  ]))
}
}

})